import './style.css'
import * as THREE from 'three'
import * as PANOLENS from 'panolens'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
// import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader'
import { Zlib } from 'three/examples/js/libs/inflate.min'

 /**
  * Model loaders init
  */
  const gltfLoader = new GLTFLoader()
  // const fbxLoader = new FBXLoader()
  window.Zlib = Zlib;


var panorama1, panorama2, panorama3, panorama4

if(window.outerWidth > 600) {
  panorama1 = new PANOLENS.ImagePanorama('/panorama/final_1.webp');
  panorama2 = new PANOLENS.ImagePanorama('/panorama/final_2.webp');
  panorama3 = new PANOLENS.ImagePanorama('/panorama/final_3.webp');
  panorama4 = new PANOLENS.ImagePanorama('/panorama/final_4.webp');
} else {
  panorama1 = new PANOLENS.ImagePanorama('/panorama/final_1Low.webp');
  panorama2 = new PANOLENS.ImagePanorama('/panorama/final_2Low.webp');
  panorama3 = new PANOLENS.ImagePanorama('/panorama/final_3Low.webp');
  panorama4 = new PANOLENS.ImagePanorama('/panorama/final_4Low.webp');
}

var book = new THREE.Group()

/**
 * GUI
 */
 import * as dat from 'lil-gui'
 const gui = new dat.GUI()
 
 //HIDE GUI
 gui.hide()
 window.addEventListener('keydown', (event)=> {
  if(event.key === 'h') {
      if(gui._hidden) gui.show()
     else gui.hide()
  }
 })

 function preloadImage(url)
 {
     var img=new Image();
     img.src=url;
 }

preloadImage('/products/Sacai.webp')
preloadImage('/products/Purple.webp')
preloadImage('/products/Monarch.webp')
preloadImage('/products/Black.webp')
preloadImage('/products/Dior.webp')
preloadImage('/products/Military.webp')
preloadImage('/products/Fragment.webp')
preloadImage('/products/2002R.webp')
preloadImage('/products/Lightning.webp')
preloadImage('/products/White.webp')
preloadImage('/icons/K.webp')

function hideLoader() {
  document.querySelector('.loader').style.display = 'none'
}

// startExperience()
// setTimeout(hideLoader, 8000);

var loadPanoramas = new Promise(function(resolve){
startExperience()
  panorama1.addEventListener('load', () => {
    window.location.href = '#2';
    panorama2.addEventListener('load', () => {
      window.location.href = '#3';
      panorama3.addEventListener('load', () => {
        window.location.href = '#4';
        panorama4.addEventListener('load', () => {
          window.location.href = '#1';
          panorama1.addEventListener('enter-fade-complete', () => {
            document.querySelector('#retour').style.display = "none"
            resolve()
          })
        })
      })
    })
  })
})

// var loadPanoramas = new Promise(function(resolve) {
//   startExperience()
//     panorama4.addEventListener('load', () => {
//       window.location.href = '#3';
//       panorama3.addEventListener('load', () => {
//         window.location.href = '#1';
//         panorama1.addEventListener('enter-fade-complete', () => {
//           resolve()
//         })
//       })
//     })
//   })

async function GO() {
  await loadPanoramas
  hideLoader()

  gltfLoader.load('/models/BOOK TV6.gltf', (gltf) => {
    book.add(gltf.scene)
    book.scale.set(0.7,0.7,0.7)
    book.position.set(-55,-5,0.2)
    book.rotation.y = -1.5
    book.visible = false
    panorama2.add(book)
  })
}

GO()

// async function enterSimulation() {  
//   startExperience()
// }

// enterSimulation().then(
//   function() {
//     document.querySelector('.loader').style.display = 'none'
//   }
// )

// function myFunc() {
  // document.querySelector('.loader').style.display = 'none'
// }
// setTimeout(myFunc, 8000);

// async function enterSimulation() {
//   try {
//     let loadSimulation = new Promise(function(resolve){
//       console.log('wwwwwww')
//     })
//   }
//   catch {
//     alert('An error has occured, please check your internet conenction and refresh the page.')
//   }
// }

function startExperience() {
  
  /**
  * Window Anchors
  */
  window.addEventListener('popstate', function () {
    if(window.location.hash == '#2') {
      viewer.setPanorama(panorama2)
    } else if (window.location.hash == '#3'){
      viewer.setPanorama(panorama3);
    } else if (window.location.hash == '#4'){
      viewer.setPanorama(panorama4);
    }
    else {
      viewer.setPanorama(panorama1);
    }
  });

  /**
  * Panorama init
  */
  var container = document.querySelector('.pano-image');

  // const panorama1 = new PANOLENS.ImagePanorama('/panorama/final_1.webp');
  // const panorama2 = new PANOLENS.ImagePanorama('/panorama/final_2.webp');
  // const panorama3 = new PANOLENS.ImagePanorama('/panorama/final_3.webp');
  // const panorama4 = new PANOLENS.ImagePanorama('/panorama/final_4.webp');
  
  var viewer = new PANOLENS.Viewer({
    container: container,
    cameraFov: 65,
    autoHideInfospot: false,
    autoRotate:false,
    autoRotateSpeed: 0.15,
    rotateSpeed: 1,
    controlBar: false,
    horizontalView: false,
    // output: 'console'    
  });
  viewer.add(panorama1, panorama2, panorama3, panorama4)
  viewer.addUpdateCallback(function () {})
  viewer.OrbitControls.noZoom = true

  if(window.outerWidth <= 600){
    viewer.setCameraFov(85);
  }
  // else{
  // }

/**
 * UI
 */
//Logo K
document.querySelector('#Logo_K').addEventListener('click', () => {
  window.open('https://kikikickz.com/')
})
//Powered by Imrsive
document.querySelector('#poweredByImrsive').addEventListener('click', () => {
  window.open('https://imrsive.com/')
})

//Audio
let audio = new Audio('/music/music.m4a');
var toggleSound = Boolean(false)
var volume = document.querySelector('#volume');
volume.addEventListener('click', () => {
  if(!toggleSound) {
    audio.play()
    audio.loop = true
    volume.src = '/icons/volumeOn.webp'
    toggleSound = true
  }
  else {
    volume.src = '/icons/volumeOff.webp'
    audio.pause()
    toggleSound = false
  }
})

//Map
document.querySelector('#map').addEventListener('click', () => {
  if(document.querySelector('.map').style.display == "none") {
    document.querySelector('.map').style.display = "block"
    document.querySelector('.map').style.animation = "appear 0.5s"
  }
  else {
    document.querySelector('.map').style.animation = "disappear 0.5s"
    document.querySelector('.map').style.display = "none"
  }
})

if(window.outerWidth <= 600){
  document.querySelector('#goTo1').addEventListener('touchstart', () => {
    window.location.href = '#1';
    document.querySelector('.map').style.display = 'none'
    document.querySelector('#retour').style.display = "none"
  })
  document.querySelector('#goTo2').addEventListener('touchstart', () => {
    window.location.href = '#2';
    document.querySelector('.map').style.display = 'none'
  })
  document.querySelector('#goTo3').addEventListener('touchstart', () => {
    window.location.href = '#3';
    document.querySelector('.map').style.display = 'none'
  })
  document.querySelector('#goTo4').addEventListener('touchstart', () => {
    window.location.href = '#4';
    document.querySelector('.map').style.display = 'none'
  })
} else {
  document.querySelector('#goTo1').addEventListener('click', () => {
    window.location.href = '#1';
    document.querySelector('.map').style.display = 'none'
    document.querySelector('#retour').style.display = "none"
  })
  document.querySelector('#goTo2').addEventListener('click', () => {
    window.location.href = '#2';
    document.querySelector('.map').style.display = 'none'
  })
  document.querySelector('#goTo3').addEventListener('click', () => {
    window.location.href = '#3';
    document.querySelector('.map').style.display = 'none'
  })
  document.querySelector('#goTo4').addEventListener('click', () => {
    window.location.href = '#4';
    document.querySelector('.map').style.display = 'none'
  })
}

/**
 * ROOM 1
 */
const zoneSpriteMap = new THREE.TextureLoader().load( '/sprite/lib.webp' )
const zoneSpriteMaterial = new THREE.SpriteMaterial( { map: zoneSpriteMap } )

const zoneSpriteMap2 = new THREE.TextureLoader().load( '/sprite/cadeaux.webp' )
const zoneSpriteMaterial2 = new THREE.SpriteMaterial( { map: zoneSpriteMap2 } )

const zoneSpriteMap3 = new THREE.TextureLoader().load( '/sprite/sneakers.webp' )
const zoneSpriteMaterial3 = new THREE.SpriteMaterial( { map: zoneSpriteMap3 } )

const toPano2 = new THREE.Sprite( zoneSpriteMaterial )
toPano2.position.set(-79, -10, -88)
toPano2.scale.set(35,35,35)
toPano2.frustumCulled = false
toPano2.addEventListener('click', function() {
  window.location.href = '#2';
});

const toPano3 = new THREE.Sprite( zoneSpriteMaterial2 );
toPano3.position.set(-105 ,2 ,0)
toPano3.scale.set(35,35,35)
toPano3.frustumCulled = false
toPano3.addEventListener('click', function() {
  window.location.href = '#3';
});

const toPano4 = new THREE.Sprite( zoneSpriteMaterial3 );
toPano4.position.set(-79, -12, 88)
toPano4.scale.set(35,35,35)
toPano4.frustumCulled = false
toPano4.addEventListener('click', function() {
 window.location.href = '#4';
});

panorama1.add(toPano2,toPano3, toPano4)

var first = 0;
panorama1.addEventListener('enter-fade-start', function (e) {
  viewer.OrbitControls.autoRotate = true
  toPano2.visible = true
  toPano3.visible = true
  toPano4.visible = true
  if(first == 0) {
    viewer.tweenControlCenter(new THREE.Vector3(1991.148001544277 ,187.42872412699074 ,14.146000083459466), 0, TWEEN.Easing.Exponential.Out);
    first = 1

    //Scratch
      var isDrawing, lastPoint;
      var scratch       = document.getElementById('js-canvas'),
      canvasWidth  = scratch.width,
      canvasHeight = scratch.height,
      ctx          = scratch.getContext('2d', { willReadFrequently: true }),
      image        = new Image(),
      brush        = new Image();
      scratch.width = '600'
      scratch.height = '600'
      image.src = '/icons/scratchzone.webp';
      image.onload = function() {
        ctx.drawImage(image, 0, 0);
        document.querySelectorAll('.form')[0].style.visibility = 'visible';
      };
      brush.src = '/icons/brush.webp';
      scratch.addEventListener('mousedown', handleMouseDown, false);
      scratch.addEventListener('touchstart', handleMouseDown, false);
      scratch.addEventListener('mousemove', handleMouseMove, false);
      scratch.addEventListener('touchmove', handleMouseMove, false);
      scratch.addEventListener('mouseup', handleMouseUp, false);
      scratch.addEventListener('touchend', handleMouseUp, false);
      function distanceBetween(point1, point2) {
        return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
      }
      function angleBetween(point1, point2) {
        return Math.atan2( point2.x - point1.x, point2.y - point1.y );
      }
      function getFilledInPixels(stride) {
        if (!stride || stride < 1) { stride = 1; }
        var pixels   = ctx.getImageData(0, 0, canvasWidth, canvasHeight),
            pdata    = pixels.data,
            l        = pdata.length,
            total    = (l / stride),
            count    = 0;
        for(var i = count = 0; i < l; i += stride) {
          if (parseInt(pdata[i]) === 0) {
            count++;
          }
        }
        return Math.round((count / total) * 100);
      } 
      function getMouse(e, scratch) {
        var offsetX = 0, offsetY = 0, mx, my;
        if (scratch.offsetParent !== undefined) {
          do {
            offsetX += scratch.offsetLeft;
            offsetY += scratch.offsetTop;
          } while ((scratch = scratch.offsetParent));
        }
        mx = (e.pageX || e.touches[0].clientX) - offsetX;
        my = (e.pageY || e.touches[0].clientY) - offsetY;
        return {x: mx, y: my};
      }
      function handlePercentage(filledInPixels) {
        filledInPixels = filledInPixels || 0;
        if (filledInPixels > 70) {
          scratch.parentNode.removeChild(scratch);
        }
      }
      
      function handleMouseDown(e) {
        isDrawing = true;
        lastPoint = getMouse(e, scratch);
      }
      function handleMouseMove(e) {
        if (!isDrawing) { return; }
        e.preventDefault();
        var currentPoint = getMouse(e, scratch),
            dist = distanceBetween(lastPoint, currentPoint),
            angle = angleBetween(lastPoint, currentPoint),
            x, y;
        for (var i = 0; i < dist; i++) {
          x = lastPoint.x + (Math.sin(angle) * i) - 25;
          y = lastPoint.y + (Math.cos(angle) * i) - 25;
          ctx.globalCompositeOperation = 'destination-out';
          ctx.drawImage(brush, x, y);
        }
        lastPoint = currentPoint;
        handlePercentage(getFilledInPixels(32));
      }
  function handleMouseUp(e) {
    isDrawing = false;
  }
  } else {
    viewer.tweenControlCenter(new THREE.Vector3(1991.148001544277 ,187.42872412699074 ,14.146000083459466), 1200, TWEEN.Easing.Exponential.Out);
  }
});

panorama1.addEventListener('leave-start', function(){
  toPano2.visible = false
  toPano3.visible = false
  toPano4.visible = false
});

/**
 * ROOM 2
 */
 const ZoneGeometry = new THREE.BoxGeometry(0, 6,6)
 const material = new THREE.MeshBasicMaterial( { transparent:true, opacity:0 } );
 // const material = new THREE.MeshBasicMaterial( { color: 0xffff00  } );
 const bookZone = new THREE.Mesh( ZoneGeometry, material );
 bookZone.position.set(-15, 3, 0.3)
 bookZone.visible = false
 bookZone.addEventListener('click', ()=> {
   window.open('https://kikikickz.com/products/sneakers-obsession')
 })
 

//TV
let tvGeometry = new THREE.BoxGeometry(0, 1920,1080)

//screen1
let video = document.querySelector("#vid"); 
let videoTexture = new THREE.VideoTexture(video);
var tvMaterial = new THREE.MeshBasicMaterial({map: videoTexture, side: THREE.FrontSide})

var TV = new THREE.Mesh( tvGeometry, tvMaterial );
TV.position.set(-3505,180, 2585);
TV.rotation.y = 0.7
TV.visible = false;

//screen2
let video2 = document.querySelector("#vid2");
video2.muted = true;
let videoTexture2 = new THREE.VideoTexture(video2);
var tvMaterial2 = new THREE.MeshBasicMaterial({map: videoTexture2,side: THREE.FrontSide})

var TV2 = new THREE.Mesh( tvGeometry, tvMaterial2 );
TV2.position.set(-3505,180, -2585);
TV2.rotation.y = -0.7
TV2.visible = false;

panorama2.add( TV, TV2,bookZone)
// const OBJ3D = gui.addFolder('TV')
//       OBJ3D
//       .add(TV.position, 'z')
//       .step(0.1)
//       .name('X')
  
//       OBJ3D
//       .add(TV.position, 'y')
//       .step(0.1)
//       .name('Y')
  
//       OBJ3D
//       .add(TV.position, 'x')
//       .step(0.1)
//       .name('Z')
  
//       OBJ3D
//       .add(TV.rotation, 'x')
//       .step(0.1)
//       .name('x')
  
//       OBJ3D
//       .add(TV.rotation, 'y')
//       .step(0.1)
//       .name('y')
  
//       OBJ3D
//       .add(TV.rotation, 'z')
//       .step(0.1)
//       .name('z')

// var book = new THREE.Group()
//   gltfLoader.load('/models/BOOK TV6.gltf', (gltf) => {
//     book.add(gltf.scene)
//     book.scale.set(0.7,0.7,0.7)
//     book.position.set(-55,-5,0.2)
//     book.rotation.y = -1.5
//     book.visible = false
//     panorama2.add(book)
//   })


const animateTV = () => {
  requestAnimationFrame( animateTV )
  videoTexture.needsUpdate = true
  videoTexture2.needsUpdate = true
};

panorama2.addEventListener('enter-fade-start', function(){
  viewer.tweenControlCenter(new THREE.Vector3(1991.148001544277 ,187.42872412699074 ,14.146000083459466), 0, TWEEN.Easing.Exponential.Out)
  bookZone.visible = true
  TV.visible = true;
  TV2.visible = true
  book.visible = true
  
});

panorama2.addEventListener('enter-fade-complete', function(){
  document.querySelector('#retour').style.display = "flex"
  video.play();
  video2.play()
  animateTV();
});

panorama2.addEventListener('leave-start', function(){
  bookZone.visible = false
  TV.visible = false
  TV2.visible = false
  book.visible = false
});



/**
 * ROOM 3
 */

panorama3.addEventListener('enter-fade-start', function(){
  viewer.tweenControlCenter(new THREE.Vector3(1991.148001544277 ,187.42872412699074 ,14.146000083459466), 1200, TWEEN.Easing.Exponential.Out)
});
viewer.OrbitControls.autoRotate = false
panorama3.addEventListener('enter-fade-complete', function(){
  document.querySelector('#retour').style.display = "flex"
});

panorama3.addEventListener('leave-start', function(){
});


/**
 * ROOM 4
 */
//Create infospots
const buySpriteMap = new THREE.TextureLoader().load( '/sprite/buySprite.webp' )
const buySpriteMaterial = new THREE.SpriteMaterial( { map: buySpriteMap } )

//Product Page Manager
var textBrand = document.querySelector('#brand')
var textName = document.querySelector('#name')
var textPrice = document.querySelector('#price')
var productImage = document.querySelector('#productImage')


var infospotGroup = new THREE.Group()

  const buy1 = new THREE.Sprite( buySpriteMaterial )
  buy1.position.set(1219.76, -509.35, 1916.90)
  buy1.scale.set(100,100,100)
  buy1.frustumCulled = false
  buy1.addEventListener('click', function() {
      //changeText
      textBrand.innerHTML = 'Nike'
      textName.innerHTML = 'Vaporwaffle Sacai Tan Navy'
      productImage.src = '/products/Sacai.webp'
     
      //show page
      document.querySelector('.product3D').style.display = 'block'
      document.querySelector('.pano-image').style.pointerEvents = "none"
  
      // if(obj1 == null) {
      //   //load model
      //   fbxLoader.load('/models/Shoes/Nike VaporWaffle Sacai Tan Wavy/SacaiXnike vaporWaffle sesame and blue Void.fbx',
      //   (object) => {
      //     object.scale.set(0.06,0.06,0.06)
      //     object.position.y = -0.25
      //     object.rotation.y = -0.6
      //     scene.add(object)
      //     obj1 = object
      //   })
      // } else {
      //   scene.add(obj1)
      // }
  });


  const buy2 = new THREE.Sprite(buySpriteMaterial)
  buy2.position.set(-41.30, -405.15, 1915.88)
  buy2.scale.set(100,100,100)
  buy2.frustumCulled = false
  buy2.addEventListener('click', function() {
    //changeText
    textBrand.innerHTML = 'Air Jordan'
    textName.innerHTML = 'Air Jordan 1 Retro High Court Purple'
    textPrice.innerHTML = 'À partir de 350€'
    productImage.src = '/products/Purple.webp'
   
    //show page
    document.querySelector('.product3D').style.display = 'block'
    document.querySelector('.pano-image').style.pointerEvents = "none"
    
    // if(obj2 == null) {
    //   mtlLoader.load("/models/Shoes/Air Jordan 1 Retro High Court Purple/nike-air-jordan-1-retro-high-court-purple-white/source/Jordan 1 Retro High Court Purple White/Jordan 1 Retro High Court Purple White.mtl", function(materials) {
    //     materials.preload();
    //     objLoader.setMaterials(materials);
    //     objLoader.load("/models/Shoes/Air Jordan 1 Retro High Court Purple/nike-air-jordan-1-retro-high-court-purple-white/source/Jordan 1 Retro High Court Purple White/Jordan 1 Retro High Court Purple White.obj", function(object) {    
    //       object.scale.set(0.005, 0.005, 0.005)
    //       object.rotation.x = -14.2
    //       scene.add(object );
    //       obj2 = object
    //     })
    //   })
    // } else {
    //   scene.add(obj2)
    // }  
  });


  const buy3 = new THREE.Sprite( buySpriteMaterial )
  buy3.position.set(-1311.45, -484.66, 1916.90)
  buy3.scale.set(100,100,100)
  buy3.frustumCulled = false
  buy3.addEventListener('click', function() {
    //changeText
    textBrand.innerHTML = 'Nike'
    textName.innerHTML = 'Air Max 1 Patta Monarch'
    textPrice.innerHTML = 'À partir de 295€'
    productImage.src = '/products/Monarch.webp'
  
    //show page
    document.querySelector('.product3D').style.display = 'block'
    document.querySelector('.pano-image').style.pointerEvents = "none"
    // if(obj3 == null) {
    //   fbxLoader.load('/models/Shoes/Nike Air Max 1 Patta Wave Monarch/Nike Air Max 1 Patta Waves Noise Aqua.fbx',
    //     (object) => {
    //       object.scale.set(0.06,0.06,0.06)
    //       object.rotation.y = -0.5
    //       object.position.y = -0.20
    //       scene.add(object)
    //       obj3 = object
    //     }
    //   )
    // } else {
    //   scene.add(obj3)
    // }
  });


  const buy4 = new THREE.Sprite( buySpriteMaterial )
  buy4.position.set(-2450, -378, 690)
  buy4.scale.set(100,100,100)
  buy4.frustumCulled = false
  buy4.addEventListener('click', function() {
     //changeText
     textBrand.innerHTML = 'Nike'
     textName.innerHTML = 'Dunk Low Black White'
     textPrice.innerHTML = 'À partir de 190€'
     productImage.src = '/products/Black.webp'

   
     //show page
     document.querySelector('.product3D').style.display = 'block'
     document.querySelector('.pano-image').style.pointerEvents = "none"
  });


  const buy5 = new THREE.Sprite( buySpriteMaterial )
  buy5.position.set(-2450, -378, 200)
  buy5.scale.set(100,100,100)
  buy5.frustumCulled = false
  buy5.addEventListener('click', function() {
    //changeText
    textBrand.innerHTML = 'Air Jordan'
    textName.innerHTML = 'Air Jordan 1 High Dior'
    textPrice.innerHTML = 'À partir de 9.720€'
    productImage.src = '/products/Dior.webp'
   
    //show page
    document.querySelector('.product3D').style.display = 'block'
    document.querySelector('.pano-image').style.pointerEvents = "none"
  });


  const buy6 = new THREE.Sprite( buySpriteMaterial )
  buy6.position.set(-2450, -378, -240)
  buy6.scale.set(100,100,100)
  buy6.frustumCulled = false
  buy6.addEventListener('click', function() {
    //changeText
    textBrand.innerHTML = 'Air Jordan'
    textName.innerHTML = 'Air Jordan 4 Military Black'
    textPrice.innerHTML = 'À partir de 410€'
    productImage.src = '/products/Military.webp'
   
    //show page
    document.querySelector('.product3D').style.display = 'block'
    document.querySelector('.pano-image').style.pointerEvents = "none"
  });


  const buy7 = new THREE.Sprite( buySpriteMaterial )
  buy7.position.set(-2450, -378, -700)
  buy7.scale.set(100,100,100)
  buy7.frustumCulled = false
  buy7.addEventListener('click', function() {
    //changeText
    textBrand.innerHTML = 'Air Jordan'
    textName.innerHTML = 'Air Jordan 1 Retro Low OG Travis Scott Fragment'
    textPrice.innerHTML = 'À partir de 1.765€'
    productImage.src = '/products/Fragment.webp'
   
    //show page
    document.querySelector('.product3D').style.display = 'block'
    document.querySelector('.pano-image').style.pointerEvents = "none"
  });


  const buy8 = new THREE.Sprite( buySpriteMaterial )
  buy8.position.set(-1318, -486, -1915)
  buy8.scale.set(100,100,100)
  buy8.frustumCulled = false
  buy8.addEventListener('click', function() {
    //changeText
    textBrand.innerHTML = 'New Balance'
    textName.innerHTML = '2002R Protection Pack Rain Cloud'
    textPrice.innerHTML = 'À partir de 390€'
    productImage.src = '/products/2002R.webp'
   
    //show page
    document.querySelector('.product3D').style.display = 'block'
    document.querySelector('.pano-image').style.pointerEvents = "none"
  
    // if(obj8 == null) {
    //   fbxLoader.load('/models/Shoes/New Balance 2002R Protection Pack Rain Cloud/new-balance-2002r-protection-pack.fbx', (object) => {
    //     object.scale.set(0.061,0.061,0.061)
    //     object.rotation.x = -1.5
    //     object.rotation.z = -0.6
    //     object.position.y = -0.20
    //     scene.add(object)
    //     obj8 = object
    //   })
    // } else {
    //   scene.add(obj8)
    // }
  });


  const buy9 = new THREE.Sprite( buySpriteMaterial )
  buy9.position.set(-68, -404, -1915)
  buy9.scale.set(100,100,100)
  buy9.frustumCulled = false
  buy9.addEventListener('click', function() {
    //changeText
    textBrand.innerHTML = 'Air Jordan'
    textName.innerHTML = 'Air Jordan 4 Retro Lightning (2021)'
    textPrice.innerHTML = 'À partir de 340€'
    productImage.src = '/products/Lightning.webp'
   
    //show page
    document.querySelector('.product3D').style.display = 'block'
    document.querySelector('.pano-image').style.pointerEvents = "none"
  });


  const buy10 = new THREE.Sprite( buySpriteMaterial )
  buy10.position.set(1206, -562, -1915)
  buy10.scale.set(100,100,100)
  buy10.frustumCulled = false
  buy10.addEventListener('click', function() {
    //changeText
    textBrand.innerHTML = 'Nike'
    textName.innerHTML = 'Air Force 1 Low Triple White'
    textPrice.innerHTML = 'À partir de 140€'
    productImage.src = '/products/White.webp'
   
    //show page
    document.querySelector('.product3D').style.display = 'block'
    document.querySelector('.pano-image').style.pointerEvents = "none"
  });


infospotGroup.add(buy1,buy2,buy3,buy4,buy5,buy6,buy7,buy8,buy9,buy10)
infospotGroup.visible = false

panorama4.add(infospotGroup)


panorama4.addEventListener('enter-fade-start', function(){
  viewer.tweenControlCenter(new THREE.Vector3(1991.148001544277 ,187.42872412699074 ,14.146000083459466), 1200, TWEEN.Easing.Exponential.Out)
  infospotGroup.visible = true
});

panorama4.addEventListener('enter-fade-complete', function(){
  document.querySelector('#retour').style.display = "flex"
});

panorama4.addEventListener('leave-start', function(){
  infospotGroup.visible = false
});


function openProduct() {
  if(textName.innerHTML == "Vaporwaffle Sacai Tan Navy"){
    window.open('https://kikikickz.com/products/sacai-x-nike-vaporwaffle-tan-navy?_pos=5&_sid=6e63adc1d&_ss=r')
  }
  else if(textName.innerHTML == "Air Jordan 1 Retro High Court Purple"){
    window.open('https://kikikickz.com/products/jordan-1-retro-high-court-purple?_pos=1&_sid=199cf0123&_ss=r')
  }
  else if(textName.innerHTML == "Air Max 1 Patta Monarch"){
    window.open('https://kikikickz.com/products/air-max-1-patta-monarch')
  }
  else if(textName.innerHTML == "Dunk Low Black White"){
    window.open('https://kikikickz.com/products/nike-dunk-low-black-white')
  }
  else if(textName.innerHTML == "Air Jordan 1 High Dior"){
    window.open('https://kikikickz.com/en/products/air-jordan-1-high-dior')
  }
  else if(textName.innerHTML == "Air Jordan 4 Military Black"){
    window.open('https://kikikickz.com/products/air-jordan-4-military-black')
  }
  else if(textName.innerHTML == "Air Jordan 1 Retro Low OG Travis Scott Fragment"){
    window.open('https://kikikickz.com/products/air-jordan-1-retro-low-og-travis-scott-fragment?_pos=1&_sid=c3501e745&_ss=r')
  }
  else if(textName.innerHTML == "2002R Protection Pack Rain Cloud"){
    window.open('https://kikikickz.com/products/2002r-protection-pack-rain-cloud?_pos=1&_sid=625a85b29&_ss=r')
  }
  else if(textName.innerHTML == "Air Jordan 4 Retro Lightning (2021)"){
    window.open('https://kikikickz.com/products/air-jordan-4-retro-lightning-2021')
  }
  else if(textName.innerHTML == "Air Force 1 Low Triple White"){
    window.open('https://kikikickz.com/products/air-force-1-low-triple-white')
  }
}

buy3DBtn.addEventListener('click', ()=> {
  openProduct()
})

buy3DBtn.addEventListener('touchstart', ()=> {
  openProduct()
})






// Canvas
// const canvas = document.querySelector('canvas.product-model')

// Scene
// const scene = new THREE.Scene()


// var obj1,obj2,obj3,obj4,obj5,obj6,obj7,obj8,obj9,obj10 = null



/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/**
 * Lights
 */
const ambientLight = new THREE.AmbientLight(0xffffff, 0.8)
viewer.add(ambientLight)

const directionalLight = new THREE.DirectionalLight(0xffffff, 0.6)
directionalLight.castShadow = true
directionalLight.shadow.mapSize.set(1024, 1024)
directionalLight.shadow.camera.far = 15
directionalLight.shadow.camera.left = - 7
directionalLight.shadow.camera.top = 7
directionalLight.shadow.camera.right = 7
directionalLight.shadow.camera.bottom = - 7
directionalLight.position.set(5, 5, 5)
viewer.add(directionalLight)


 
let mixer = null

//gift
var gift = new THREE.Group()

//gift zone to trigger animation
const giftZone = new THREE.Mesh( ZoneGeometry, material );
giftZone.position.set(-15, -1, 0)
giftZone.visible = false

//Card
const cardGeometry = new THREE.BoxGeometry(0, 0, 0)

// const cardMaterial = new THREE.MeshBasicMaterial( { color: 0x0000ff  } );
const cardTexture = new THREE.TextureLoader().load( '/icons/cardTexture.webp' )
const cardMaterial = new THREE.MeshBasicMaterial( {  map: cardTexture  } );
cardMaterial.map.minFilter = THREE.LinearFilter;
const card = new THREE.Mesh( cardGeometry, cardMaterial );
card.visible = false
card.position.set(-66, -18, 0)
card.rotation.z = -0.1
panorama3.add(card)

//Load Gift model
gltfLoader.load('/models/GIFT.gltf', (gltf) => {
  // console.log(gltf)
  gift.add(gltf.scene)
  // let object = gltf.scene.children[0]
  gift.scale.set(10,10,10)
  gift.position.set(-123,-19,-2)
  gift.rotation.y = 1.43
  
  panorama3.add(gift)
  
  gift.visible = false
  panorama3.addEventListener('enter-fade-start', function(){
    // card.visible = true
    gift.visible = true
    giftZone.visible = true
  });
  
  panorama3.addEventListener('leave-start', function(){
    card.visible = false
    gift.visible = false
    giftZone.visible = false
  });
  
  giftZone.addEventListener('click', ()=> {
    //center camera and disable controls
    viewer.tweenControlCenter(new THREE.Vector3(1991.148001544277 ,187.42872412699074 ,14.146000083459466), 1200, TWEEN.Easing.Exponential.Out);
    viewer.OrbitControls.autoRotate = false

    //bring gift forward
    var giftForward = new TWEEN.Tween(gift.position)
    .to( { x:-70 }, 1000)
    .easing(TWEEN.Easing.Cubic.Out)

    // var cardElevate = new TWEEN.Tween(card.position)
    //   .to({ y:-2}, 800)
    //   .onStart(function(){
    //     card.visible = true
    //     new TWEEN.Tween(card.scale)
    //     .to({ x:0.1, y:10, z:14}, 1800)
    //     .to({ x:0.7, y:70, z:98}, 1800)
    //     // .to({ x:1, y:100, z:140}, 1800)
    //     .start()
    //   })
      var cardElevate = new TWEEN.Tween(card.position)
      .to({ y:3 }, 500)
      .onStart(function(){
        card.visible = true
        new TWEEN.Tween(card.scale)
        .to({ x:0.1, y:10, z:14}, 500)
        .start()
      })

      var cardGrow = new TWEEN.Tween(card.position)
      .to({ x:-15, z:0}, 500)
      .onComplete(function(){
        document.querySelector('#giftContainer').style.display = "block"
        document.querySelector('#giftContainer').style.animation = "appear 0.5s"
        viewer.OrbitControls.enabled = false
      })
      // .onStart(function(){
      //   // card.visible = true
      //   // new TWEEN.Tween(card.scale)
      //   // .to({ x:0.1, y:10, z:14}, 1800)
      //   // .start()
      // })

    // giftForward.chain(cardElevate );
    // cardElevate.chain( giftForward );

    giftForward.start()
    cardElevate.delay(1200)
    cardElevate.start()
    cardGrow.delay(1400)
    cardGrow.start()
    


    //start opening animation
    mixer = new THREE.AnimationMixer(gltf.scene)  
    // gltf.animations[0].duration = 3
    const action = mixer.clipAction(gltf.animations[0])
    action.timeScale = 3
    action.setLoop(THREE.LoopOnce)
    action.clampWhenFinished = true
    action.enable = true
    action.play()
    // giftZone.visible = false
  })
  panorama3.add( giftZone );
})

/**
 * Animate Scene
 */
 const clock = new THREE.Clock()
 let previousTime = 0
 
 const tick = () =>
 {
   const elapsedTime = clock.getElapsedTime()
   const deltaTime = elapsedTime - previousTime
   previousTime = elapsedTime
 
   // Model animation
   if(mixer)
   {
     mixer.update(deltaTime)
   }

   if(window.location.hash == '#2') {
      book.position.y = Math.cos(elapsedTime)
      book.rotation.x = Math.sin(elapsedTime) * 0.05;
      book.rotation.y += 0.009
   }

   TWEEN.update();
   window.requestAnimationFrame(tick)   
 }
 
 tick()
     
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Keyboard controls
 */
document.body.onkeyup = (e) => {
  if (e.key == " " ||
      e.code == "Space" ||      
      e.keyCode == 32      
  ) {
    viewer.tweenControlCenter(new THREE.Vector3(1991.148001544277 ,187.42872412699074 ,14.146000083459466), 1200, TWEEN.Easing.Exponential.Out);
  }
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// panorama4.addEventListener( 'enter-fade-complete',()=>{

  /**
   * Base
   */
  // // Canvas
  // const canvas = document.querySelector('canvas.product-model')

  // // Scene
  // const scene = new THREE.Scene()

  /**
   * Axes Helper
   */
  // const axesHelper = new THREE.AxesHelper( 5 );
  // scene.add( axesHelper );


  /**
   * Models
   */
  
  // fbxLoader.load('/models/Shoes/Nike VaporWaffle Sacai Tan Wavy/SacaiXnike vaporWaffle sesame and blue Void.fbx',
  //   (object) => {
  //     object.scale.set(0.06,0.06,0.06)
  //     object.position.y = -0.25
  //     object.rotation.y = -0.6
  //     // scene.add(object)
  //   }
  // )
  
  // //!\\
  // fbxLoader.load('/models/Shoes/Nike Dunk Low Black White/nike-dunk-high-pbr.fbx',
  //   (object) => {
  //     object.scale.set(0.0004,0.0004,0.0004)
  //     object.position.y = -0.25
  //     object.rotation.x = -1.5
  //     object.rotation.z = -0.4
  //     // scene.add(object)
  //   }
  // )

  // fbxLoader.load('/models/Shoes/Nike Air Max 1 Patta Wave Monarch/Nike Air Max 1 Patta Waves Noise Aqua.fbx',
  //   (object) => {
  //     object.scale.set(0.06,0.06,0.06)
  //     object.rotation.y = -0.5
  //     object.position.y = -0.20
  //     // scene.add(object)
  //   }
  // )
  
  // fbxLoader.load('/models/Shoes/New Balance 2002R Protection Pack Rain Cloud/new-balance-2002r-protection-pack.fbx',
  //   (object) => {
  //     object.scale.set(0.061,0.061,0.061)
  //     object.rotation.x = -1.5
  //     object.rotation.z = -0.6
  //     object.position.y = -0.20
  //     // scene.add(object)
  //   }
  // )

  //!\\
  // fbxLoader.load('models/Shoes/Air Jordan 4 Military Black/jordan-4-military-black/source/Jordan4_Jumpman.fbx',
  //   (object) => {
  //     console.log(object)
  //     object.scale.set(0.061,0.061,0.061)
  //     object.rotation.x = -1.5
  //     object.rotation.z = -0.6
  //     object.position.y = -0.20
  //     // scene.add(object)

  //     const OBJ3D = gui.addFolder('OBJ3D')
  //     OBJ3D
  //     .add(object.position, 'z')
  //     .step(0.1)
  //     .name('X')

  //     OBJ3D
  //     .add(object.position, 'y')
  //     .step(0.1)
  //     .name('Y')

  //     OBJ3D
  //     .add(object.position, 'x')
  //     .step(0.1)
  //     .name('Z')

  //     OBJ3D
  //     .add(object.rotation, 'x')
  //     .step(0.1)
  //     .name('x')

  //     OBJ3D
  //     .add(object.rotation, 'y')
  //     .step(0.1)
  //     .name('y')

  //     OBJ3D
  //     .add(object.rotation, 'z')
  //     .step(0.1)
  //     .name('z')
  //   }
  // )

  //!\\
  // fbxLoader.load('/models/Shoes/Air Jordan 4 Lightning/jordan-4-retro-lightning/source/Jordan4_JumpmanSketch.fbx',
  //   (object) => {
  //     object.scale.set(0.061,0.061,0.061)
  //     object.rotation.x = -1.5
  //     object.rotation.z = -0.6
  //     object.position.y = -0.20
  //     // scene.add(object)

  //     const OBJ3D = gui.addFolder('OBJ3D')
  //     OBJ3D
  //     .add(object.position, 'z')
  //     .step(0.1)
  //     .name('X')

  //     OBJ3D
  //     .add(object.position, 'y')
  //     .step(0.1)
  //     .name('Y')

  //     OBJ3D
  //     .add(object.position, 'x')
  //     .step(0.1)
  //     .name('Z')

  //     OBJ3D
  //     .add(object.rotation, 'x')
  //     .step(0.1)
  //     .name('x')

  //     OBJ3D
  //     .add(object.rotation, 'y')
  //     .step(0.1)
  //     .name('y')

  //     OBJ3D
  //     .add(object.rotation, 'z')
  //     .step(0.1)
  //     .name('z')
  //   }
  // )

  //!\\
  // fbxLoader.load('/models/Shoes/Air Jordan 1 Retro Low OG Travis Scott Fragment/TRAVIS SCOTT x Fragment Design x Air Jordan 1 Low OG SP.fbx',
  //   (object) => {
  //     object.scale.set(0.061,0.061,0.061)
  //     object.rotation.x = -1.5
  //     object.rotation.z = -0.6
  //     object.position.y = -0.20
  //     // scene.add(object)

  //     const OBJ3D = gui.addFolder('OBJ3D')
  //     OBJ3D
  //     .add(object.position, 'z')
  //     .step(0.1)
  //     .name('X')

  //     OBJ3D
  //     .add(object.position, 'y')
  //     .step(0.1)
  //     .name('Y')

  //     OBJ3D
  //     .add(object.position, 'x')
  //     .step(0.1)
  //     .name('Z')

  //     OBJ3D
  //     .add(object.rotation, 'x')
  //     .step(0.1)
  //     .name('x')

  //     OBJ3D
  //     .add(object.rotation, 'y')
  //     .step(0.1)
  //     .name('y')

  //     OBJ3D
  //     .add(object.rotation, 'z')
  //     .step(0.1)
  //     .name('z')
  //   }
  // )

  // var mtlLoader = new MTLLoader();
  // mtlLoader.load("/models/Shoes/Air Jordan 1 Retro High Court Purple/nike-air-jordan-1-retro-high-court-purple-white/source/Jordan 1 Retro High Court Purple White/Jordan 1 Retro High Court Purple White.mtl", function(materials) {
  //   materials.preload();
  //   var objLoader = new OBJLoader();
  //   objLoader.setMaterials(materials);
  //   objLoader.load("/models/Shoes/Air Jordan 1 Retro High Court Purple/nike-air-jordan-1-retro-high-court-purple-white/source/Jordan 1 Retro High Court Purple White/Jordan 1 Retro High Court Purple White.obj", function(object) {    
  //     object.scale.set(0.005, 0.005, 0.005)
  //     object.rotation.x = -14.2
  //     // scene.add(object );
  //   })
  // })

  // fbxLoader.load('/models/Shoes/Air Jordan 1 High Dior/jordan-1-dior-shoe/source/Jordan 1 Dior.fbx',
  //   (object) => {
  //     object.scale.set(0.061,0.061,0.061)
  //     object.rotation.x = -1.5
  //     object.rotation.z = -0.6
  //     object.position.y = -0.20
  //     // scene.add(object)

  //     const OBJ3D = gui.addFolder('OBJ3D')
  //     OBJ3D
  //     .add(object.position, 'z')
  //     .step(0.1)
  //     .name('X')

  //     OBJ3D
  //     .add(object.position, 'y')
  //     .step(0.1)
  //     .name('Y')

  //     OBJ3D
  //     .add(object.position, 'x')
  //     .step(0.1)
  //     .name('Z')

  //     OBJ3D
  //     .add(object.rotation, 'x')
  //     .step(0.1)
  //     .name('x')

  //     OBJ3D
  //     .add(object.rotation, 'y')
  //     .step(0.1)
  //     .name('y')

  //     OBJ3D
  //     .add(object.rotation, 'z')
  //     .step(0.1)
  //     .name('z')
  //   }
  // )
  
  // mtlLoader.load("/models/Shoes/Air Force Triple White/air-force-1-low-nike-pbr/source/AirForce01_OBJ.mtl", function(materials)
  // {
  //     materials.preload();
  //     var objLoader = new OBJLoader();
  //     objLoader.setMaterials(materials);
  //     objLoader.load("/models/Shoes/Air Force Triple White/air-force-1-low-nike-pbr/source/AirForce01_OBJ.obj", function(object)
  //     {    
  //         // scene.add(object );
  //     });
  // });

  /**
   * Lights
   */
  // const ambientLight1 = new THREE.AmbientLight(0xffffff, 1.1)
  // scene.add(ambientLight1)

  /**
   * Sizes
   */
  // const sizes = {
  //     width: window.innerWidth,
  //     height: window.innerHeight
  // }

  // window.addEventListener('resize', () =>
  // {
  //     // Update sizes
  //     sizes.width = window.innerWidth
  //     sizes.height = window.innerHeight

  //     // Update camera
  //     camera.aspect = sizes.width / sizes.height
  //     camera.updateProjectionMatrix()

  //     // Update renderer
  //     renderer.setSize(sizes.width, sizes.height)
  //     renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
  // })

  /**
   * Camera
   */
  // Base camera
  // const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
  // camera.position.set(-2, 0, 0)
  // scene.add(camera)

  // Controls
  // const controls = new OrbitControls(camera, canvas)
  // controls.enablePan = false
  // controls.target.set(0, 0, 0)
  // controls.autoRotate = false
  // controls.autoRotateSpeed = 0.6
  // controls.enableDamping = true
  // controls.dampingFactor = 0.6
  // controls.enableZoom = false;

  /**
   * Renderer
   */
  // const renderer = new THREE.WebGLRenderer({
  //     canvas: canvas,
  //     alpha:true
  // })
  // renderer.shadowMap.enabled = true
  // renderer.shadowMap.type = THREE.PCFSoftShadowMap
  // renderer.setSize(sizes.width, sizes.height)
  // renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

    if(window.outerWidth <= 600){
      document.querySelector('#retour').addEventListener('touchstart',()=>{
        window.location.href = '#1';
        document.querySelector('#retour').style.display = "none"
      })

      document.querySelector('#exitProduct').addEventListener('touchstart',()=>{
        document.querySelector('.product3D').style.display = 'none'
        document.querySelector('.pano-image').style.pointerEvents = "auto"
      })

      document.querySelector('#exitGift').addEventListener('touchstart',()=>{
        document.querySelector('#giftContainer').style.display = "none"
        document.querySelector('#codeTag').style.display = "block"
        viewer.OrbitControls.enabled = true
        viewer.OrbitControls.autoRotate = true
      })
    } else {
      document.querySelector('#retour').addEventListener('click',()=>{
        window.location.href = '#1';
        document.querySelector('#retour').style.display = "none"
      })

      document.querySelector('#exitProduct').addEventListener('click',()=>{
        document.querySelector('.product3D').style.display = 'none'
        document.querySelector('.pano-image').style.pointerEvents = "auto"
      })
    
      document.querySelector('#exitGift').addEventListener('click',()=>{
        document.querySelector('#giftContainer').style.display = "none"
        document.querySelector('#codeTag').style.display = "block"
        viewer.OrbitControls.enabled = true
        viewer.OrbitControls.autoRotate = true
      })
    }

// panorama1.load()
// panorama2.load()
// panorama3.load()
// panorama4.load()

// panorama4.addEventListener('loaded', ()=> {
//   console.log('loaded')
// })


// panorama4.addEventListener('load', ()=> {
//   console.log('load')
// })

// document.querySelector("#myInput").addEventListener('click', ()=> {
//   // Get the text field
//   var copyText = document.getElementById("myInput");

//   // Select the text field
//   copyText.select();
//   copyText.setSelectionRange(0, 99999); // For mobile devices

//    // Copy the text inside the text field
//   navigator.clipboard.writeText(copyText.value);

//   // Alert the copied text
//   alert("Copied the text: " + copyText.value);
// })

if(window.outerWidth <= 600){
  document.querySelector("#codeBtn").addEventListener('touchstart', ()=> {
    navigator.clipboard
      .writeText(document.getElementById("codeBtn").innerHTML)
      .then(() => {
        console.log("Copied the code: " + document.getElementById("codeBtn").innerHTML);
      })
      .catch(() => {
        // console.log("something went wrong");
      });
  })
  document.querySelector("#codeTag").addEventListener('touchstart', ()=> {
    navigator.clipboard
      .writeText(document.getElementById("codeBtn").innerHTML)
      .then(() => {
        console.log("Copied the code: " + document.getElementById("codeBtn").innerHTML);
        document.querySelector('#codeTag').style.color = '#44986C'
      })
      .catch(() => {
        // console.log("something went wrong");
      });
  })
} else {
  document.querySelector("#codeBtn").addEventListener('click', ()=> {
    navigator.clipboard
      .writeText(document.getElementById("codeBtn").innerHTML)
      .then(() => {
        console.log("Copied the code: " + document.getElementById("codeBtn").innerHTML);
      })
      .catch(() => {
        // console.log("something went wrong");
      });
  })
  document.querySelector("#codeTag").addEventListener('click', ()=> {
    navigator.clipboard
      .writeText(document.getElementById("codeBtn").innerHTML)
      .then(() => {
        console.log("Copied the code: " + document.getElementById("codeBtn").innerHTML);
        document.querySelector('#codeTag').style.color = '#44986C'
      })
      .catch(() => {
        // console.log("something went wrong");
      });
  })
}

/**
 * Gift card's date
 */
 var date = new Date();
 const weekday = ["Dimanche","Lundi","Mardi","Mercredi","Jeudi","Vendredi","Samedi"];
 let day = weekday[date.getDay()];
 var dd = String(date.getDate()).padStart(2, '0');
 var month = date.toLocaleString('default', { month: 'long' });
 var today = day + ' ' + dd + ' ' + month
 document.querySelector("#date").innerHTML = today

}


